import React from 'react';

import styled from 'styled-components';

import { 
    Container, 
    ContainerWrap, 
    ContainerPadding,
    ContainerHorizontalAlignment
} from '../../../components-core/packages/components-core/dist/container/index';
import { IntegratorRoot } from '../../../components-core/packages/components-core/dist/integrator-root/index';
import { 
    Text, 
    TextAppearance, 
    TextAlignment, 
} from '../../../components-core/packages/components-core/dist/text';
import { Breakpoints } from '../../../components-core/packages/components-core/dist/helpers';
import { Image } from '../../../components-core/packages/components-core/dist/image/index';
import { BreakpointWrapper } from '../../../components-core/packages/components-core/dist/breakpoint-wrapper/index';

//CUSTOM COMPONENTS
import Color from '../model-colors/Color';


const TopContainer = styled.div`
    width: 100vw;
    display: flex;
    flex-direction: column;
    overflow: hidden;
`;

const TopColorContainer = styled.div`

    display: flex;
    justify-content: center;

    @media screen and (max-width: 768px) {
        display: flex;
        flex-wrap: nowrap;
        overflow-x: auto;
        -webkit-overflow-scrolling: touch;
        justify-content: flex-start;
    }
`;


class ModelColorsNew extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            selectedIndex: 0,
        }

        this.staticContainerPaddingVertical = { 
            top: ContainerPadding.grid001, 
        }

        this.staticContainerPaddingHorizontal = {
            left: ContainerPadding.grid002,
            right: ContainerPadding.grid002,
            ...this.staticContainerPaddingVertical
        }

        const defaultHorizontalAlign = ContainerHorizontalAlignment.center;
        this.descriptionHorizontalAlignment = {
            [Breakpoints.b2560]: defaultHorizontalAlign,
            [Breakpoints.b1920]: defaultHorizontalAlign,
            [Breakpoints.b1600]: defaultHorizontalAlign,
            [Breakpoints.b1280]: defaultHorizontalAlign,
            [Breakpoints.b960]: defaultHorizontalAlign,
        }


        const centerAlignnment = TextAlignment.center;

        this.textAlign = {
            [Breakpoints.b2560]: centerAlignnment,
            [Breakpoints.b1920]: centerAlignnment,
            [Breakpoints.b1600]: centerAlignnment,
            [Breakpoints.b1280]: centerAlignnment,
            [Breakpoints.b960]: centerAlignnment,
        }


        const grid004Padding = ContainerPadding.grid004;
        const grid002Padding = ContainerPadding.grid002;

        const imagePadding = {
            [Breakpoints.b2560]: grid004Padding,
            [Breakpoints.b1920]: grid004Padding,
            [Breakpoints.b1600]: grid004Padding,
            [Breakpoints.b1280]: grid004Padding,
            [Breakpoints.b960]: grid002Padding,
        }

        this.image4DimensionsPadding = {
            left: imagePadding,
            right: imagePadding,
            top: ContainerPadding.dynamic0100
        }

        const colorContainerPaddings = {
            [Breakpoints.b2560]: grid004Padding,
            [Breakpoints.b1920]: grid004Padding,
            [Breakpoints.b1600]: grid004Padding,
            [Breakpoints.b1280]: grid004Padding,
            [Breakpoints.b960]: grid002Padding,
            [Breakpoints.b560]: grid002Padding
        }

        this.colorContainerPadding = {
            left: colorContainerPaddings,
            right: colorContainerPaddings,
            top: ContainerPadding.dynamic0150
        }
    }

    renderTitle() {
        const { custom, custom1 } = this.props;

        return (
            <Container wrap={ContainerWrap.always}>
                <h2><Text appearance={TextAppearance.headline0400} bold>
                    {custom}
                </Text>
                <Text appearance={TextAppearance.label0200}>
                    {custom1}
                </Text></h2>
            </Container>

        )
    }

    renderImage() {
        const {custom5} = this.props;
        let data;
        if(custom5 == 1) {
            data = dataElevenSet(this.props);
        }else {
            data = dataSet(this.props);
        }
        return (
            <Container padding={this.image4DimensionsPadding}>
                <Image src={data[this.state.selectedIndex].carPhoto} alt={'volkwagen-ticari'} />
            </Container>
        )
    }

    renderDescription() {
        const {custom5} = this.props;
        let data;
        if(custom5 == 1) {
            data = dataElevenSet(this.props);
        }else {
            data = dataSet(this.props);
        }
        return (
            <Container wrap={ContainerWrap.always} padding={this.staticContainerPaddingVertical} >
                <Text textAlign={this.textAlign} appearance={TextAppearance.copy0200}>
                    Seçilen Renk
                </Text>
                <Text textAlign={this.textAlign}  appearance={TextAppearance.label0250} bold>
                    {data[this.state.selectedIndex].colorName}
                </Text>                            
            </Container>
        )
    }

    renderColor() {
        const {custom5} = this.props;
        let data;
        if(custom5 == 1) {
            data = dataElevenSet(this.props);
        }else {
            data = dataSet(this.props);
        }
        const dataLenght = data.length;
        const renderedColors = data.map((item, index) => 
                        <Color 
                        selectedIndex={this.state.selectedIndex} 
                        index={index} 
                        dataLength={dataLenght}
                        onClick={() => this.setState({ selectedIndex: index })} 
                        colorImage={item.colorSmallImage}
                    />                 
            
        )

        return (
            <Container 
                horizontalAlign={this.descriptionHorizontalAlignment}
                padding={this.colorContainerPadding}
            >
                <BreakpointWrapper max={Breakpoints.b560}>
                    <TopColorContainer>
                        {renderedColors}
                    </TopColorContainer>
                </BreakpointWrapper>
                <BreakpointWrapper min={Breakpoints.b560}>
                    <Container>
                        {renderedColors}
                    </Container>
                </BreakpointWrapper>
            </Container> 
        )
    }

    render() {
        return (
            <TopContainer>
                <Container 
                    padding={{ 
                        top: ContainerPadding.dynamic0250, 
                        bottom: ContainerPadding.dynamic0250 
                    }}
                    horizontalAlign={ContainerHorizontalAlignment.center}
                >
                    <Container 
                        wrap={ContainerWrap.always}
                        padding={this.staticContainerPaddingHorizontal}
                    >
                        {this.renderTitle()}
                        {this.renderImage()}
                        {this.renderDescription()}
                    </Container>
                    {this.renderColor()}
                </Container>
            </TopContainer>
        
        )
    }
}

const dataSet = (props) => [
    {
        colorName: props.custom2.split('-')[0],
        carPhoto: props.custom3.split('-')[0],
        colorSmallImage: props.custom4.split('-')[0]
    },
    {
        colorName: props.custom2.split('-')[1],
        carPhoto: props.custom3.split('-')[1],
        colorSmallImage: props.custom4.split('-')[1]
    },
    {
        colorName: props.custom2.split('-')[2],
        carPhoto: props.custom3.split('-')[2],
        colorSmallImage: props.custom4.split('-')[2]
    },
    {
        colorName: props.custom2.split('-')[3],
        carPhoto: props.custom3.split('-')[3],
        colorSmallImage: props.custom4.split('-')[3]
    },
    {
        colorName: props.custom2.split('-')[4],
        carPhoto: props.custom3.split('-')[4],
        colorSmallImage: props.custom4.split('-')[4]
    },
    {
        colorName: props.custom2.split('-')[5],
        carPhoto: props.custom3.split('-')[5],
        colorSmallImage: props.custom4.split('-')[5]
    },
    {
        colorName: props.custom2.split('-')[6],
        carPhoto: props.custom3.split('-')[6],
        colorSmallImage: props.custom4.split('-')[6]
    },
    {
        colorName: props.custom2.split('-')[7],
        carPhoto: props.custom3.split('-')[7],
        colorSmallImage: props.custom4.split('-')[7]
    },
    {
        colorName: props.custom2.split('-')[8],
        carPhoto: props.custom3.split('-')[8],
        colorSmallImage: props.custom4.split('-')[8]
    },
    {
        colorName: props.custom2.split('-')[9],
        carPhoto: props.custom3.split('-')[9],
        colorSmallImage: props.custom4.split('-')[9]
    },
    {
        colorName: props.custom2.split('-')[10],
        carPhoto: props.custom3.split('-')[10],
        colorSmallImage: props.custom4.split('-')[10]
    },
    {
        colorName: props.custom2.split('-')[11],
        carPhoto: props.custom3.split('-')[11],
        colorSmallImage: props.custom4.split('-')[11]
    },
    {
        colorName: props.custom2.split('-')[12],
        carPhoto: props.custom3.split('-')[12],
        colorSmallImage: props.custom4.split('-')[12]
    },   
]

    const dataElevenSet = (props) => [
    {
        colorName: props.custom2.split('-')[0],
        carPhoto: props.custom3.split('-')[0],
        colorSmallImage: props.custom4.split('-')[0]
    },
    {
        colorName: props.custom2.split('-')[1],
        carPhoto: props.custom3.split('-')[1],
        colorSmallImage: props.custom4.split('-')[1]
    },
    {
        colorName: props.custom2.split('-')[2],
        carPhoto: props.custom3.split('-')[2],
        colorSmallImage: props.custom4.split('-')[2]
    },
    {
        colorName: props.custom2.split('-')[3],
        carPhoto: props.custom3.split('-')[3],
        colorSmallImage: props.custom4.split('-')[3]
    },
    {
        colorName: props.custom2.split('-')[4],
        carPhoto: props.custom3.split('-')[4],
        colorSmallImage: props.custom4.split('-')[4]
    },
    {
        colorName: props.custom2.split('-')[5],
        carPhoto: props.custom3.split('-')[5],
        colorSmallImage: props.custom4.split('-')[5]
    },
    {
        colorName: props.custom2.split('-')[6],
        carPhoto: props.custom3.split('-')[6],
        colorSmallImage: props.custom4.split('-')[6]
    },
    {
        colorName: props.custom2.split('-')[7],
        carPhoto: props.custom3.split('-')[7],
        colorSmallImage: props.custom4.split('-')[7]
    },
    {
        colorName: props.custom2.split('-')[8],
        carPhoto: props.custom3.split('-')[8],
        colorSmallImage: props.custom4.split('-')[8]
    },
    {
        colorName: props.custom2.split('-')[9],
        carPhoto: props.custom3.split('-')[9],
        colorSmallImage: props.custom4.split('-')[9]
    },
    {
        colorName: props.custom2.split('-')[10],
        carPhoto: props.custom3.split('-')[10],
        colorSmallImage: props.custom4.split('-')[10]
    }, 
]

export default ModelColorsNew;

const colors = [1,2,3,4,5,6,7,8,9]